export const SCREEN_SIZES = {
    xs: '0',
    sm: '575px',
    md: '768px',
    lg: '991px',
    xl: '1200px',
}